module.exports = __webpack_public_path__ + "static/media/13.5ce5be79.jpg";